import loadable from '@loadable/component';
import {  useState } from 'react'
import usePostHook from '../../customHooks/usePostHook';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import Spinner from '../../components/Reusable/Spinner';
import moment from 'moment';

const RiderKMRecordComponent = loadable(
  () => import("../../components/RiderKMRecord/RiderKMRecord")
);

const RiderKMRecord = () => {
  const [currentMonth, setCurrentMonth] = useState(moment())
  const [refetchDate, setRefetch] = useState(currentMonth.format('YYYY-MM-DD'))
  const [customDateFilter, setCustomDateFiler] = useState<any>({})

  const { data: kmRecordSetting, refetch } = useGetHook({
    queryKey: ["km-record-settings"],
    url: APIS.KM_RECORD_SETTING,
    params: {
    },
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["km-record-settings"],
    navigateURL: "",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.KM_RECORD_SETTING}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };


  const { data: kmRecord, isLoading } = useGetHook({
    queryKey: ["km-record", refetchDate, customDateFilter],
    url: APIS.KM_RECORD,
    params: {
      start_date: customDateFilter?.start_date??currentMonth.startOf('month').format('YYYY-MM-DD'),
      end_date: customDateFilter?.end_date??currentMonth.endOf('month').format('YYYY-MM-DD')
    },
  });

  return (
    <>
      {isLoading ? <Spinner /> :
        <RiderKMRecordComponent
          handleCreate={handleCreate}
          kmRecordSetting={kmRecordSetting}
          isPostLoading={isPostLoading}
          refetch={refetch}
          isLoading={isLoading}
          kmRecord={kmRecord}
          setCurrentMonth={setCurrentMonth}
          currentMonth={currentMonth}
          setRefetch={setRefetch}
          setCustomDateFiler={setCustomDateFiler}
        />
      }
    </>
  )
}

export default RiderKMRecord
